module.exports = __webpack_public_path__ + "mercury-1-29d679c5c2abf9b9a9fb1a947dbb58ea.webp";